import { render } from "./NewTDACartRecap.vue?vue&type=template&id=d9556938&scoped=true"
import script from "./NewTDACartRecap.vue?vue&type=script&lang=js"
export * from "./NewTDACartRecap.vue?vue&type=script&lang=js"

import "./NewTDACartRecap.vue?vue&type=style&index=0&id=d9556938&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9556938"]])

export default __exports__